var PropertyDetailsBuilderErrors = {
  
  general: function (errors) {
    var err = [];

    if (errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(errors.base[i]);
      }
    }

    var field_names = [
      'name',
      'app_domain',
      'address_1',
      'city',
      'state',
      'main_telephone',
      'tollfree_telephone',
      'mobile_telephone',
      'fax_telephone',
      'tdd_telephone',
      'twilio_number',
      'website_url',
      // 'images'
    ];

    for (var i = 0, ilen = field_names.length; i < ilen; i++) {
      var field_errors = errors[field_names[i]];
      if (field_errors && field_errors.length) {
        for (var j = 0, jlen = field_errors.length; j < jlen; j++) {
          err.push(I18n.t(field_names[i]) + ' ' + field_errors[j]);
        }
      }
    }

    return err;
  },
  locks: function (errors) {
    var err = [];

    if (errors.remotelock_grace_period_in_minutes && errors.remotelock_grace_period_in_minutes.length) {
      for (var i = 0, ilen = errors.remotelock_grace_period_in_minutes.length; i < ilen; i++) {
        err.push(I18n.t('remotelock_grace_period') + ' ' + errors.remotelock_grace_period_in_minutes[i]);
      }
    }

    return err;
  },
}

export default PropertyDetailsBuilderErrors
